<script>
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import TextField from '@/commons/FormElements/TextField.vue';

export default {
    components: {
        TextField,
    },
    name: 'LoginEmailPassword',
    data() {
        return {
            email: '',
            password: '',
            isShowPassword: false,
        };
    },
    methods: {
        _onPerformLoginSuccess(responseData) {
            DibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(responseData)) {
                if (!responseData.is_verified) {
                    this.$cookies.set('_token', responseData.token, '365d');
                    this.$cookies.set(
                        '_user', responseData,
                        '365d'
                    );
                    this.$emit('goToDashboard');
                } else {
                    this.$emit('performVerificationProgress', responseData);
                }
            } else {
                DibbleJs.toastErrorMessage(responseData.message);
            }
        },
        onSubmit() {
            const { email, password } = this;
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.login,
                email,
                password,
            };
            DibbleJs.callApiRequest(data, this._onPerformLoginSuccess);
        },
        toggleShowPassword() {
            this.isShowPassword = !this.isShowPassword;
        },
    },
};
</script>

<template>
    <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <TextField
                v-model="email"
                name="email"
                label="Email"
                rules="required|email"
            />
            <TextField
                v-model="password"
                name="password"
                label="Password"
                rules="required"
                :type="isShowPassword ? 'text' : 'password'"
            >
                <template #append-icon>
                    <a @click.prevent="toggleShowPassword">
                        <i
                            class="fa text-secondary"
                            :class="[
                                isShowPassword ? 'fa-eye-slash' : 'fa-eye',
                            ]"
                        />
                    </a>
                </template>
            </TextField>
            <div class="d-flex align-center flex-wrap justify-content-end">
                <RouterLink to="/" class="text-primary text-body-2">
                    Forgot Password?
                </RouterLink>
            </div>
            <button class="btn-dialog btn-sm ok-btn w-100 mt-5" type="submit">
                LOG IN
            </button>
        </form>
    </ValidationObserver>
</template>
